export default `
<div class='page-footer'>
  <div class='footer-container'>
    <div class="informaltable footer-container table-responsive">
      <div class="preloader-container show">
        <div class="loader"></div>
      </div>
      <table class="informaltable frame-void rules-rows">
        <tbody>
          <tr>
            <td class="td">
              <p class="subscription-container">
              </p>
            </td>
            <td class="td">
              <div class="itemizedlist">
                <ul class="itemizedlist">
                  <li class="listitem">
                    <p>
                      <span class="icon icon-comment" /> 
                      Got feedback? 
                      <a class="link" href="https://forms.gle/RBnHjhYP2YVgj3dm9" target="_blank" rel="noopener">
                        Let us know.
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-link" /> 
                      Connect with 
                      <a class="link" href="https://community.rapyd.net/" target="_blank" rel="noopener">
                        Rapyd Developer Community
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-question-mark" /> 
                      Need help? 
                      <a class="link" href="https://dashboard.rapyd.net/login" target="_blank" rel="noopener">
                        Contact us.
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-privacy" /> 
                      <a class="link" href="https://www.rapyd.net/security-compliance/site-privacy-policy/" target="_blank" rel="noopener">
                        Privacy policy
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
`;
